/* Old School Photo Lab — Order prints · assets/ospl-cart-thumbs.js · v0.1.0
   Shows a thumbnail of the customer's own print in the cart (cart page and cart
   drawer) for lines added from the Order prints page, in the picture spot next to
   the product name. Loaded on every page from layout/theme.liquid.

   Where the picture comes from, first that exists:
     1. the line's _thumb property: the thumbnail's lasting address on our host
        (prints/thumb.php), set when uploads are on;
     2. this browser's own copy, kept by the Order prints page when the print was
        added (localStorage 'ospl-op-thumbs', by the line's _line id). That is
        what shows in test mode, and the fallback if 1 can't load.
   Which cart rows are Order prints lines comes from /cart.js (_app starts
   "order-prints"), matched to the theme's rows by their data-key (the line key).
   Other products' rows are never touched. Shopify's own checkout pages can't be
   changed on this plan, so there the line shows without a picture. */
(function(){
  'use strict';
  if(window.__osplCartThumbs) return;
  window.__osplCartThumbs=true;

  var ROW='tr.cart-items__table-row[data-key]';
  var style=document.createElement('style');
  style.textContent='.ospl-op-thumb{display:flex;align-items:center;justify-content:center;aspect-ratio:1;width:100%;background:rgb(0 0 0 / .05);border-radius:4px;overflow:hidden}'+
    '.ospl-op-thumb img{display:block;width:100%;height:100%;object-fit:contain}';
  document.head.appendChild(style);

  var lines=null, known={}, loading=null;
  function root(){ return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'; }
  function loadCart(){
    if(loading) return loading;
    loading=fetch(root()+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(c){
        var m={}, k={};
        (c&&c.items||[]).forEach(function(it){
          var p=it.properties||{};
          k[it.key]=1;
          if(String(p._app||'').indexOf('order-prints')===0) m[it.key]={line:String(p._line||''),thumb:String(p._thumb||''),name:String(p.Photo||'')};
        });
        lines=m; known=k; loading=null; return m;
      })
      .catch(function(){ loading=null; return lines||{}; });
    return loading;
  }
  function local(){
    try{ return JSON.parse(localStorage.getItem('ospl-op-thumbs')||'{}')||{}; }catch(e){ return {}; }
  }
  function place(row,L,loc){
    var td=row.querySelector('.cart-items__media');
    if(!td||td.querySelector('.ospl-op-thumb')) return;
    var mine=loc[L.line]&&loc[L.line].u;
    var src=L.thumb||mine;
    if(!src) return;
    var box=document.createElement('span'); box.className='ospl-op-thumb';
    var img=document.createElement('img');
    img.alt=L.name?('Your print of '+L.name):'Your print';
    img.decoding='async';
    if(L.thumb&&mine) img.addEventListener('error',function(){ img.src=mine; },{once:true});
    img.src=src;
    box.appendChild(img);
    td.textContent='';
    td.appendChild(box);
  }
  function fill(fresh){
    var rows=document.querySelectorAll(ROW);
    if(!rows.length) return;
    var unknown=false;
    for(var i=0;i<rows.length;i++){ if(!lines||!known[rows[i].getAttribute('data-key')]){ unknown=true; break; } }
    var go=function(m){
      var loc=local();
      document.querySelectorAll(ROW).forEach(function(r){ var L=m[r.getAttribute('data-key')]; if(L) place(r,L,loc); });
    };
    if(fresh||unknown) loadCart().then(go); else go(lines);
  }

  var timer=0;
  function soon(fresh){ clearTimeout(timer); timer=setTimeout(function(){ fill(fresh); },60); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ soon(true); });
  else soon(true);
  document.addEventListener('cart:update',function(){ lines=null; soon(true); });
  new MutationObserver(function(ms){
    for(var i=0;i<ms.length;i++){ if(ms[i].addedNodes&&ms[i].addedNodes.length){ soon(false); return; } }
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
